<template>
  <div>
    <div class="row">
      <div class="col-md-8">
        <Heading title="Uninstall" subTitle="Before you uninstall Superchargify from Shopify, please follow these steps to remove Superchargify's code from your store." />
      </div>
    </div>

    <div class="row row-settings">
      <div class="col-md-4">
        <h2 class="h6">Action</h2>
        <p class="font-weight-normal mb-0">Remove Superchargify's code from your store.</p>
      </div>
      <div class="col-md-8">
        <div class="card bs">
          <div class="card-body">
            <div v-if="selfUninstalled" class="form-group mb-0">
              <Alert class="alert-danger" icon="IconImportant" title="As per your request, we have removed Superchargify's code from your store.">
                <p class="font-weight-normal mb-1">
                  <ExternalLink :href="'https://' + shopObj.myshopify_domain + '/admin/apps'" text="You can now uninstall Superchargify from your Shopify Dashboard" class="alert-link font-weight-normal" />
                </p>
              </Alert>

              <div class="form-group mb-0">
                <p class="font-weight-normal">Didn't mean to uninstall Superchargify?</p>
                <ProcessButton
                  class="mb-3"
                  type="reinstall"
                  successText="We have received your request for reinstallation of the code. It will be processed within next 15 min."
                  buttonClass="btn-primary"
                  :submitText="'Reinstall Superchargify\'s code in ' + shopObj.name"
                  :noReflect="true"
                  submittingText="Reinstalling..." />
              </div>
            </div>
            <div v-else class="form-group mb-0">
              <p class="font-weight-normal">After this action, you can uninstall Superchargify from Shopify.</p>
              <ProcessButton
                class="mb-3"
                type="selfUninstall"
                successText="We have received your request for code removal. It will be processed within next 15 min."
                buttonClass="btn-danger"
                :submitText="'Remove Superchargify\'s code from ' + shopObj.name"
                :noReflect="true"
                :confirm="{
                  icon: 'IconCloseCircle',
                  iconClass: 'danger',
                  text: 'Are you sure you want to uninstall Superchargify\'s code from your store?',
                  buttonText: 'Uninstall',
                  buttonClass: 'btn-danger'
                }"
                submittingText="Removing..." />
            </div>
            <p class="mb-0 font-weight-bolder">
              <router-link to="/help">Have any questions? We are here to help &rsaquo;</router-link>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import ProcessButton from '@/components/ProcessButton'

export default {
  components: {
    ProcessButton
  },
  computed: mapState([ 'shopObj', 'selfUninstalled' ])
}
</script>
